import { IButton, TranslateService } from '@devinforius/i-essentials';
import { DetailsScanComponent } from './details-scan.component';
import { ScanSplitButton } from '@devinforius/i-scan/lib/interfaces';

export function getQuickButtonsIScan(translate: TranslateService): ScanSplitButton[] {
  return [
    {
      id: 'createAMailFile',
      tooltip: translate.translate('iScan.action.createAMailFile'),
      action: 'createAMailFile',
      icon: 'bi bi-pencil-square',
    },
    {
      id: 'scrollFile',
      tooltip: translate.translate('iScan.action.showFile'),
      action: 'scrollFile',
      icon: 'bi bi-mouse',
    },
    {
      id: 'downloadFile',
      tooltip: translate.translate('iScan.action.downloadFile'),
      action: 'downloadFile',
      icon: 'bi bi-download',
    },
  ];
}

export function getButtonsTitle(component: DetailsScanComponent, translate: TranslateService): IButton[] {
  return [
    {
      text: translate.translate('back'),
      icon: 'bi bi-arrow-left-circle',
      iconPosition: 'left',
      styleClass: 'blue',
      click: (): void => component.quitButton(),
    },
    {
      text: translate.translate('iScan.action.archiveLot'),
      icon: 'bi bi-scissors',
      iconPosition: 'left',
      styleClass: 'red',
      click: (): void => component.archiveLotButton(),
    },
    {
      text: translate.translate('iScan.action.manageAll'),
      styleClass: 'green',
      click: (): void => null,
      childrenItems: [
        {
          label: translate.translate('iScan.action.processAll'),
          icon: 'bi bi-pen',
          click: (): void => component.processAllButton(),
        },
        {
          label: translate.translate('iScan.action.attachAll'),
          icon: 'bi bi-paperclip',
          click: (): void => component.attachAllButton(),
        },
      ],
    },
  ];
}
